export const defaultStaticColors = ['background'];
export const propertyPickerStaticColors = [
    'ppPolygonBorder',
    'ppComingForSale',
    'ppForSale',
    'ppReserved',
    'ppSold',
    'ppPartiallyOwned',
];
//# sourceMappingURL=types.js.map